

/*--------------------------------------------------------------
# Slick Slider
--------------------------------------------------------------*/
var imgCarousel = jQuery('.slick-img-slider');

if (imgCarousel.length > 0) {
    // set slides to same height
    imgCarousel.on('setPosition', function () {
        jQuery(this).find('.slick-img-slider__item').height('auto');
        var slickTrack = jQuery(this).find('.slick-track');
        var slickTrackHeight = jQuery(slickTrack).height();
        jQuery(this).find('.slick-img-slider__item').css('height', slickTrackHeight + 'px');
    });

    // initiate slider for home page
    imgCarousel.slick({
        mobileFirst: true,
        dots: false,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
        prevArrow: false,
        nextArrow: false,
        responsive: [
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                }
            }
        ]
    });
}
